import { motion } from "framer-motion";
import { useState } from "react";
import { useSwipeable } from "react-swipeable";

const SingleProductSwipe = ({ product, loading, onSwipeUp, onSwipeDown }) => {
  // Extract medium-sized images from productImages
  const mediumImages = product?.productImages
    ?.flatMap((imagesGroup) => imagesGroup)
    ?.filter((img) => img.size === "med")
    ?.map((img) => img.url) || [];

  const [currentIndex, setCurrentIndex] = useState(0); // Current image index
  const [swipeDirection, setSwipeDirection] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  // Handle swipe left
  const onSwipeLeft = () => {
    setSwipeDirection("left");
    setIsVisible(false);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === mediumImages.length - 1 ? 0 : prevIndex + 1
      );
      setIsVisible(true);
    }, 300);
  };

  // Handle swipe right
  const onSwipeRight = () => {
    setSwipeDirection("right");
    setIsVisible(false);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? mediumImages.length - 1 : prevIndex - 1
      );
      setIsVisible(true);
    }, 300);
  };

  // Handle swipe up
  const handleSwipeUp = () => {
    if (onSwipeUp) {
      onSwipeUp();
    }
  };

  // Handle swipe down
  const handleSwipeDown = () => {
    if (onSwipeDown) {
      onSwipeDown();
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: onSwipeLeft,
    onSwipedRight: onSwipeRight,
    onSwipedUp: handleSwipeUp,
    onSwipedDown: handleSwipeDown,
    preventDefaultTouchmoveEvent: true,
    trackTouch: true,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="flex flex-col h-screen overflow-hidden relative"
      {...handlers}
      style={{ height: "calc(100vh - 120px)" }}
    >
      <motion.div
        key={currentIndex} // Key changes when the image changes
        className="relative"
        initial={{ x: swipeDirection === "left" ? "100%" : "-100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: swipeDirection === "left" ? "-100%" : "100%", opacity: 0 }}
        transition={{ type: "tween", duration: 0.3 }}
      >
        <img
          src={mediumImages[currentIndex]}
          alt={product.name}
          className="w-full h-full object-cover rounded-xl"
          style={{ height: "calc(100vh - 150px)" }}
        />
        <div
          className="absolute bottom-0 left-0 w-full h-[70%] text-white p-4 py-2 rounded-b-xl flex flex-col justify-end"
          style={{
            background: "linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent)",
          }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <h2 className="text-xl font-bold mb-0">{product.name}</h2>
            <p className="text-lg mt-0 mb-2">
              ₹{product.price}{" "}
              <span className="line-through text-gray-400 text-base">
                ₹{product.markedPrice}
              </span>
            </p>
            <p className="text-sm font-[200] mt-0 mb-1">{product.description}</p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default SingleProductSwipe;
